<ion-content scrollY="false">
	<ion-list *ngIf="items.length > 0" lines="full">
		<ion-item *ngFor="let item of items" (click)="execute(item)">
			<ion-icon *ngIf="item.icon" slot="start" [name]="item.icon"></ion-icon>
			<ion-label class="white-space">{{ item.title }}</ion-label>
		</ion-item>
	</ion-list>
</ion-content>